webpackJsonp([31,35],{

/***/ 42:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(44),
	  /* template */
	  __webpack_require__(58),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 44:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'boNumber',
	  props: {
	    value: {
	      type: Number,
	      default: 0
	    },
	    max: {
	      type: Number,
	      default: 9999
	    },
	    min: {
	      type: Number,
	      default: 0
	    }
	  },
	  methods: {
	    getValue: function getValue() {
	      return this.valueSelf;
	    },
	    getOldValue: function getOldValue() {
	      return this.valueSelf;
	    },
	    plus: function plus() {
	      if (this.valueSelf < this.max) {
	        this.valueSelf = this.valueSelf - 0 + 1;
	        this.$emit('on-change', this.valueSelf);
	        this.$emit('input', this.valueSelf);
	      } else {
	        this.$emit('on-max', this.valueSelf);
	      }
	    },
	    sub: function sub() {
	      if (this.valueSelf >= 1 && this.valueSelf > this.min) {
	        this.valueSelf -= 1;
	        this.$emit('on-change', this.valueSelf);
	        this.$emit('input', this.valueSelf);
	      } else {
	        this.$emit('on-min', this.valueSelf);
	      }
	    },
	    setBtn: function setBtn(params) {
	      if (params.right) {
	        this.rightBtnState = params.right;
	      }
	      if (params.left) {
	        this.leftBtnState = params.left;
	      }
	    },
	    rollback: function rollback() {
	      this.valueSelf = this.valueOld;
	    },
	    fresh: function fresh(val) {
	      console.log('fresh');
	
	      var newVal = val || this.valueSelf;
	
	      if (this.valueSelf < this.min) {
	        this.valueSelf = this.min;
	      }
	      if (this.valueSelf > this.max) {
	        this.valueSelf = this.max;
	      }
	      if (this.valueSelf === 0) {
	        this.setBtn({
	          left: 'hidden'
	        });
	      }
	
	      if (newVal >= this.max) {
	        this.setBtn({
	          right: 'disable'
	        });
	        this.setBtn({
	          left: 'active'
	        });
	      } else if (newVal <= this.min) {
	        this.setBtn({
	          right: 'active'
	        });
	        this.setBtn({
	          left: 'hidden'
	        });
	      } else {
	        this.setBtn({
	          right: 'active'
	        });
	        this.setBtn({
	          left: 'active'
	        });
	      }
	    }
	  },
	  created: function created() {
	    this.fresh();
	  },
	
	  watch: {
	    max: function max() {
	      var _this = this;
	
	      setTimeout(function () {
	        _this.fresh();
	      }, 1);
	    },
	    min: function min() {
	      this.fresh();
	    },
	    valueSelf: function valueSelf(newVal, oldVal) {
	      this.valueOld = oldVal;
	      this.fresh(newVal);
	    },
	    value: function value(newval) {
	      this.valueSelf = newval;
	    }
	  },
	  data: function data() {
	    return {
	      valueSelf: this.value,
	      valueOld: this.value,
	      leftBtnState: 'active',
	      rightBtnState: 'active'
	    };
	  }
	};

/***/ }),

/***/ 58:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "flex-box number"
	  }, [_c('div', {
	    staticClass: "flex-item"
	  }, [_c('button', {
	    class: ['btn-icon', 'number-btn-' + this.leftBtnState],
	    attrs: {
	      "type": "button"
	    },
	    on: {
	      "click": _vm.sub
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-jian-xianxingyuankuang"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item-1"
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.valueSelf),
	      expression: "valueSelf"
	    }],
	    class: ['number-input', 'flex-item-1', _vm.valueSelf == 0 ? 'number-input-hidden' : ''],
	    attrs: {
	      "type": "text",
	      "readonly": ""
	    },
	    domProps: {
	      "value": (_vm.valueSelf)
	    },
	    on: {
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.valueSelf = $event.target.value
	      }
	    }
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "flex-item"
	  }, [_c('button', {
	    class: ['btn-icon', 'number-btn-' + this.rightBtnState],
	    attrs: {
	      "type": "button",
	      "name": "button"
	    },
	    on: {
	      "click": _vm.plus
	    }
	  }, [_c('i', {
	    staticClass: "icon iconfont icon-jia-yuankuang"
	  })])])])
	},staticRenderFns: []}

/***/ }),

/***/ 62:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(1)(
	  /* script */
	  __webpack_require__(107),
	  /* template */
	  __webpack_require__(264),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 107:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _boNumber = __webpack_require__(42);
	
	var _boNumber2 = _interopRequireDefault(_boNumber);
	
	var _menuVertical = __webpack_require__(13);
	
	var _menuVertical2 = _interopRequireDefault(_menuVertical);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: '',
	  components: {
	    BoNumber: _boNumber2.default,
	    menuVertical: _menuVertical2.default
	  },
	  methods: {
	    change: function change(val) {
	      this.val = val;
	    },
	    max: function max() {
	      this.$toast.open('已到最大值');
	    },
	    min: function min() {
	      this.$toast.open('到最小值');
	    },
	    rollback: function rollback() {
	      var _this = this;
	
	      this.$toast.open('1S后回滚');
	      setTimeout(function () {
	        _this.$refs.number.rollback();
	      }, 1000);
	    }
	  },
	  data: function data() {
	    return {
	      val: 1,
	      val2: 2,
	      val3: 1
	    };
	  }
	};

/***/ }),

/***/ 264:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('ul', {
	    staticClass: "list list-box p0002"
	  }, [_c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("值 " + _vm._s(_vm.val))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-number', {
	    attrs: {
	      "max": "5",
	      "value": "0"
	    },
	    on: {
	      "on-change": _vm.change
	    }
	  })], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("大小上下限 " + _vm._s(_vm.val2))]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-number', {
	    attrs: {
	      "max": "5",
	      "min": "2"
	    },
	    on: {
	      "on-max": _vm.max,
	      "on-min": _vm.min
	    },
	    model: {
	      value: (_vm.val2),
	      callback: function($$v) {
	        _vm.val2 = $$v
	      },
	      expression: "val2"
	    }
	  })], 1)])], 1), _vm._v(" "), _c('li', {
	    staticClass: "list-item"
	  }, [_c('menu-vertical', [_c('span', {
	    attrs: {
	      "slot": "body"
	    },
	    slot: "body"
	  }, [_vm._v("数据回滚")]), _vm._v(" "), _c('span', {
	    staticStyle: {
	      "padding-right": "20px"
	    },
	    attrs: {
	      "slot": "dock"
	    },
	    slot: "dock"
	  }, [_c('bo-number', {
	    ref: "number",
	    attrs: {
	      "value": _vm.val3
	    },
	    on: {
	      "on-change": _vm.rollback
	    }
	  })], 1)])], 1)])
	},staticRenderFns: []}

/***/ })

});


// WEBPACK FOOTER //
// static/js/31.2868501399d7eef139e2.js